<template>
	<StandardModal data-context="Accredited Investors Modal" @modal-close="close">
		<template #title>
			<h3 class="heading-5">Accredited investors</h3>
		</template>
		<template #content>
			<p>
				An accredited investor must have an annual income in excess of $200,000 (or $300,000 joint income) for
				the last two years and expectation of the same for the current year, or household net worth in excess of
				$1 million, not including your primary residence.
			</p>
		</template>
		<template #button-section>
			<div></div>
		</template>
	</StandardModal>
</template>

<script setup lang="ts">
import StandardModal from '@components/modals/standard-modal.vue';

interface Emits {
	(e: 'modal-close'): void;
}

const emit = defineEmits<Emits>();

function close(): void {
	emit('modal-close');
}
</script>
